module.exports = __webpack_public_path__ + "static/media/popo-neutral.50e94793.png";